import tw, { styled } from 'twin.macro';

const StyledError = styled.div`
  ${tw`block text-sm font-medium text-red-500 mt-2 text-left`};
`;

export default StyledError;
